export const REACTJS_BOILERPLATE_API = 'http://localhost:8000/api/';
